import React, { useEffect,useState } from "react";
import JdsPriorityInternal from "../../jdsPriorityInternal";

export default function NuJobsJDsPriorityInternal(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <JdsPriorityInternal product = {"nujobs"}/>
    </div>  
  );
}
